<template>
  <v-select
    v-model="dataItem.id_currencies"
    :options="currencies"
    label="symbol"
    :reduce="item => item.id"
    placeholder="Seçiniz"
    class="custom-v-select"
    :clearable="false"
    :filterable="false"
    @input="getCurrency"
  />
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'CurrencySelect',
  components: {
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
    currencies() {
      return this.$store.getters['currencies/dataList']
    },
  },
  created() {
    this.getCurrencies()
  },
  methods: {
    getCurrency() {
      this.$store.dispatch('currencies/getDataItem', this.dataItem.id_currencies)
        .then(response => {
          if (response) {
            this.dataItem.currency = response.symbol
          }
        })
    },
    getCurrencies() {
      this.$store.dispatch('currencies/getDataList', {
        select: [
          'currencies.id AS id',
          'currencies.title AS title',
          'currencies.symbol AS symbol',
        ],
      })
    },
  },
}
</script>
<style>
.custom-v-select{
  width: 100px;
  margin: 0 !important;
  padding: 0 !important;
}
.custom-v-select .vs__dropdown-toggle{
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  height: 38px;
}
</style>
